module.exports = __webpack_public_path__ + "static/img/Consulting07.8a55bd31.png";